<template>
  <div class="auth">
    <div
      class="container"
      v-html="configurations.about_content.config_value"
    ></div>
  </div>
</template>
<script>
export default {
  name: "About",
  data() {
    return {
      configurations: JSON.parse(localStorage.getItem("configs")),
    };
  },
  mounted() {
    window.addEventListener("localstorageChange", (event) => {
      this.configurations = JSON.parse(event.detail.storage.configs);
    });
  },
};
</script>
